<jb-hero
  *ngIf="heroData"
  #hero
  [breadcrumbs]="breadcrumbs"
  [theme]="heroData?.heroTheme"
  type="primary"
  [imageSrc]="heroImage?.src"
  [withChapterSelector]="includeChapterSelector"
>
  <jb-background
    [repeat]="heroData.backgroundRepeat | jbBooleanFromString"
    [color]="heroData.backgroundColor"
    [src]="heroData.backgroundImage || ''"
  >
    <dot-background-overlay
      *ngFor="let overlay of heroData?.backgroundOverlay"
      [bgHexColor]="overlay?.bgColorForOverlay"
      [opacity]="overlay?.opacity | jbStringToNumber"
      [opacityType]="overlay?.opacityType"
    >
    </dot-background-overlay>
  </jb-background>
  <jb-flag
    *ngIf="heroData?.flagTitle"
    [theme]="heroData?.heroTheme === 'dark' ? 'light' : 'dark'"
    class="mb2"
    [title]="heroData?.flagTitle"
  ></jb-flag>
  <ng-container JbTitle>
    {{ heroData.pageTitle }}
  </ng-container>
  <ng-container JbSubheader *ngIf="heroData.tagline">
    {{ heroData?.tagline }}
  </ng-container>
  <ng-container JbDescription>
    {{ heroData?.subcopy }}
  </ng-container>
  <jb-chapter-selector [theme]="heroData?.heroTheme">
    <h3 class="screen-reader-only" jbChapterSelectorHeading>Contents</h3>
    <ul>
      <ng-container
        *ngFor="
          let section of sectionsData | slice: 0:8;
          let i = index;
          let last = last
        "
      >
        <li [ngClass]="{ active: activeIndex === i }" (click)="activeIndex = i">
          <a
            href="javascript:void(0)"
            routerLink="."
            queryParamsHandling="merge"
            [fragment]="section.data.title || section.title | dotStringToId"
            [ngClass]="heroData?.heroTheme === 'dark' ? 'white' : 'royal-blue'"
          >
            {{
              section.data && section.data.title
                ? section.data.title
                : section.title
            }}
          </a>
        </li>
      </ng-container>
    </ul>
  </jb-chapter-selector>
</jb-hero>
